import { VerifyUserAuthType, UserProfileType } from "./types";

export const userProfileSlr = (state: any): UserProfileType => state.user.profile;

export const userAuthSlr = (state: any): VerifyUserAuthType => state.user.auth;
